<template>
  <div v-if="data" class="sidemenu" :class="data && data.collapsed?'':' active'">
    <template v-if="data.items && data.items.length > 0">
      <div class="text-right">
        <button
          type="button"
          class="btn btn-link btn-sm toggle_menu_btn text-dark"
          @click="toggleSideMenu()"
        >
          <i class="fa fa-times" />
          <!-- {{ $t("component.toggle_btn.hide_sidemenu") }} -->
        </button>
      </div>
    </template>
    <div>
      <div v-if="data.items && data.items.length > 0">
        <!-- <div class="animated fadeIn" v-view.once v-if="data.items && data.items.length > 0"> -->
        <h4 v-if="data.title">{{ data.title }}</h4>
        <ul id="leftmenu-list" class="marked-list list-unstyled m-0">
          <li
            v-for="(item, index) in data.items"
            :id="`marked-item-${index}`"
            :key="`marked-item-${index}`"
          >
            <CustomLink :url="item.url">{{ item.name }}</CustomLink>
            <ul v-if="item.sub_menus" class="list-unstyled m-0">
              <li
                v-for="(child, i) in item.sub_menus"
                :id="`marked-item-${i}`"
                :key="`marked-item-${i}`"
              >
                <CustomLink :url="child.url">{{ child.name }}</CustomLink>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="data.past_bene" class="animated fadeIn past_bene">
        <h4>{{ $t('component.past_beneficiaries') }}</h4>
        <ul
          v-if="pdf_items"
          id="past_beneficiaries-list"
          class="marked-list marked-list_pdf list-unstyled m-0"
        >
          <li
            v-for="(item, index) in pdf_items"
            :id="`marked-item-${index}`"
            :key="`marked-item-${index}`"
          >
            <a :href="getAssetLink(item.file)" target="_blank">
              {{ item.name }}
              <i class="fa fa-download ml-1" aria-hidden="true" />
            </a>
          </li>
        </ul>
      </div>
      <div v-if="data.current_bene" v-view.once class="animated fadeIn current_bene">
        <h4>{{ $t('component.beneficiaries') }}</h4>
        <ul id="beneficiaries-list" class="marked-list list-unstyled m-0">
          <li
            v-for="(item, index) in bene_items"
            :id="`marked-item-${index}`"
            :key="`marked-item-${index}`"
          >
            <router-link
              :to="`beneficiaries/${item.category}#b${item.article_id}`"
            >{{ getDataValue("headline", item) }}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import CustomLink from "@/components/CustomLink";

export default {
  name: "SideMenu",
  components: { CustomLink },
  props: ["data"],
  data() {
    return {
      pdf_items: [],
      bene_items: []
    };
  },
  mounted() {
    if (this.data.past_bene) {
      this.$http
        .get("report/list/beneficiaries")
        .then(response => {
          this.pdf_items = response.data.data;
        })
        .finally(() => {});
    }
    if (this.data.current_bene) {
      this.$http
        .get("/beneficiaries/list/all")
        .then(response => {
          this.bene_items = response.data.data;
        })
        .finally(() => {});
    }
  },
  methods: {
    toggleSideMenu() {
      this.data.collapsed = !this.data.collapsed;
    }
  }
};
</script>
<style scoped lang="scss">
.sidemenu > div > div + div {
  margin-top: 30px;
}
.marked-list_pdf li a:before {
  content: url("/images/btn_pdf.png") !important;
  position: absolute;
  left: 0;
  top: 12px;
}
</style>